module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","setDate"],"commonjs":"date-fns/set_date/index","commonjs2":"date-fns/set_date/index"}
// module id = 56
// module chunks = 0